import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const ShopEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Http.get(`/accounts/shops/${id}`)
      .then((res) => {
        setInputs(res.data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    Http.put(`/accounts/shops/${id}`, inputs)
      .then((res) => {
        navigate("/shops", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Shop</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Shop Information</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>Shop Name <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Enter Shop Name"
                    />
                  </div>
                  <div className="col-lg">
                    <label>Balance</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      name="balance"
                      value={inputs.balance || ""}
                      onChange={handleChange}
                      placeholder="Enter Balance"
                    />
                  </div>
                </div>
                <div className="row mg-t-20">
                  <div className="col-lg">
                    <label>Address</label>
                    <textarea
                      className="form-control"
                      name="address"
                      value={inputs.address || ""}
                      onChange={handleChange}
                      placeholder="Enter Shop Address"
                      rows="3"
                    />
                  </div>
                </div>
                <div className="row mg-t-20">
                  <div className="col-lg">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="status"
                        checked={inputs.status || false}
                        onChange={handleChange}
                        id="status"
                      />
                      <label className="form-check-label" htmlFor="status">
                        Active Status
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row mg-t-30">
                  <div className="col-lg">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-save mg-r-10"></i>
                      Update Shop
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary mg-l-10"
                      onClick={() => navigate("/shops")}
                    >
                      <i className="fa fa-times mg-r-10"></i>
                      Cancel
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopEdit;